import React, { useCallback, useContext, useState } from "react";
import useApiEp from "../../hooks/useApiEp";
import { API_ENDPOINT } from "../../utils/constants";
import ChatbotList from "../autoreply/ChatbotList";
import {
  Alert,
  Box,
  Button,
  Container,
  IconButton,
  Pagination,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import {
  getErrorResponse,
  getHeader,
  saveToken,
  toastError,
} from "../../utils/util";
import MuPb from "../../widgets/MuPb";
import TopTitleActions from "../../widgets/TopTitleActions";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useNavigate, useParams } from "react-router-dom";
import CustomCircularP from "../../widgets/CustomCircularP";
import { toast } from "react-toastify";
import axios from "axios";
import PageTitle from "../../widgets/PageTitle";
import SearchIcon from "@mui/icons-material/Search";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { debounce } from "lodash";
import BackBtn from "../../widgets/BackBtn";
import { LoadingButton } from "@mui/lab";
import { UserContext } from "../../context/UserProvider";
import { useDialog } from "../../context/DialogContext";
const UsersList = () => {
  const { id } = useParams();
  const { showDialog } = useDialog();
  const { user, loading, refreshUser } = useContext(UserContext);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [name, setName] = useState("");
  const [deleting, setDeleting] = useState(false);
  const [sq, setSq] = useState("");
  const navigate = useNavigate();
  const [logginIn, setLoggingIn] = useState(false);

  const debouncedSearch = useCallback(
    debounce((value) => {
      setSq(value);
    }, 500),
    [] // Empty dependency array to ensure the debounced function is created once
  );

  // Update searchQuery when name changes
  const handleSearchChange = (value) => {
    setName(value); // Update input value immediately
    debouncedSearch(value); // Trigger debounced search
  };
  const handleUserLogin = useCallback(
    async (email, password) => {
      try {
        setLoggingIn(true);
        const { data } = await axios.post(`${API_ENDPOINT}/user/login`, {
          email,
          password,
        });
        saveToken(data.token);
        refreshUser();
        navigate("/home"); // 👈 Transitions instantly without reloading the page
      } catch (error) {
        toastError(error);
      } finally {
        setLoggingIn(false);
      }
    },
    [navigate]
  );
  const { data, isLoading, isError, error, refetch } = useApiEp(
    `/root/get-users?page=${page}&name=${sq}&customerId=${id}`
  );

  const handleDelete = (userId) => {
    showDialog("Please confirm", "Are you sure you want to delete this user?", {
      type: "delete",
      onConfirm: async () => {
        try {
          setDeleting(true);
          const response = await axios.delete(
            `${API_ENDPOINT}/root/delete-user/${userId}`,
            getHeader()
          );
          await refetch();
          toast.success(response.data.message);
        } catch (error) {
          toastError(error);
        } finally {
          setDeleting(false);
        }
      },
    });
  };

  if (isError) {
    return <Alert severity="error">{getErrorResponse(error)}</Alert>;
  }
  return (
    <Container sx={{ mt: 3 }}>
      <CustomCircularP show={logginIn} />
      <BackBtn />
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", sm: "center" },
          gap: 2,
          mb: 3,
        }}
      >
        <PageTitle>Users List</PageTitle>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={1}
          sx={{
            width: { xs: "100%", sm: "auto" },
            mt: { xs: 1, sm: 0 },
          }}
        >
          <TextField
            size="small"
            value={name}
            onChange={(e) => handleSearchChange(e.target.value)}
            placeholder="Search User"
            InputProps={{ startAdornment: <SearchIcon fontSize="small" /> }}
          />

          <Button
            onClick={() => {
              navigate(`/home/${id}/add-user`);
            }}
            variant="outlined"
            startIcon={<AddOutlinedIcon />}
          >
            Add User
          </Button>
        </Stack>
      </Box>
      <CustomCircularP show={deleting || isLoading} />
      <Box>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="customer table">
            <TableHead sx={{ bgcolor: "background.default" }}>
              <TableRow>
                <TableCell>S.No.</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Password</TableCell>
                <TableCell>Created On</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {data?.data?.map((item, index) => (
                <TableRow hover key={index}>
                  <TableCell>{(page - 1) * limit + index + 1}</TableCell>
                  <TableCell>{item.agentName || item.profileName}</TableCell>
                  <TableCell>{item.email}</TableCell>
                  <TableCell>{item.password}</TableCell>

                  <TableCell>
                    {new Date(item.createdOn || item.updatedOn).toLocaleString(
                      "en-IN",
                      {
                        dateStyle: "medium",
                        timeStyle: "short",
                      }
                    )}
                  </TableCell>
                  <TableCell>
                    <LoadingButton
                      size="small"
                      variant="outlined"
                      onClick={() => {
                        handleUserLogin(item.email, item.password);
                      }}
                    >
                      Login
                    </LoadingButton>
                    <IconButton
                      onClick={() => {
                        handleDelete(item._id);
                      }}
                      color="error"
                      size="small"
                    >
                      <DeleteOutlineIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Box display={"flex"} justifyContent={"center"} my={2}>
          <Pagination
            count={data?.totalPages}
            page={page}
            onChange={(e, page) => {
              setPage(page);
            }}
            color="primary"
            showFirstButton
            showLastButton
          />
        </Box>
      </Box>
    </Container>
  );
};

export default UsersList;
